/**
 * Waitlist seed data — Phase 3 UAT addition (WAIT-01).
 *
 * Counts are static seed values that drive FOMO copy ("4,217 на листата",
 * "73% од 6,000 места заземени", days-to-beta countdown). The form-submit
 * path is wired to the real backend in WaitlistForm.tsx (POST /api/v1/waitlist).
 * Live queue stats would need a separate `GET /api/v1/waitlist/stats` endpoint
 * — backend doesn't expose one yet, so these seed numbers stay until then.
 *
 * The recent-signup ticker is rendered from `src/locales/{mk,en}.json`
 * `waitlist.recent.entries.0..7` so the strings localize naturally.
 *
 * Beta date is intentionally close — moves with the calendar to keep urgency.
 * Update WAITLIST_BETA_DATE manually whenever the real beta target shifts.
 */

export const WAITLIST_BASE_COUNT = 4217;
export const WAITLIST_BETA_CAP = 6000;
export const WAITLIST_BETA_DATE = '2026-05-15';

export const RECENT_SIGNUPS = [0, 1, 2, 3, 4, 5, 6, 7] as const;

/**
 * Whole-day countdown to a target ISO date. Clamped to 0 so a past date
 * doesn't show a negative number. Shared by Hero (live chip + caption) and
 * Waitlist (stats strip) so the count stays in sync across surfaces.
 */
export function daysUntil(dateStr: string): number {
  const target = new Date(dateStr).getTime();
  if (Number.isNaN(target)) return 0;
  const diff = target - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}
